import {
  Collection1k04j3hzsbod0 as Collection,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  VOID7hggqo3abtya as VOID,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  HashMap1a0ld5kgwhmhv as HashMap,
  toMutableList20rdgwi7d3cwi as toMutableList,
  LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap,
  collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault,
  mapCapacity1h45rc3eh9p2l as mapCapacity,
  coerceAtLeast2bkz8m9ik7hep as coerceAtLeast,
  Unit_instanceat14thlj150z as Unit_instance,
  toMutableMapr5f3w62lv8sk as toMutableMap,
  toMutableSetjdpdbr9jsqq8 as toMutableSet,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  KtMap140uvy3s5zad8 as KtMap,
  isInterface3d6p8outrmvmk as isInterface,
  KtMutableMap1kqeifoi36kpz as KtMutableMap,
  addAll21mdhg523wnoa as addAll,
  KtMutableList1beimitadwkna as KtMutableList,
  AbstractList3ck35puwbp1e9 as AbstractList,
  IndexOutOfBoundsException1qfr429iumro0 as IndexOutOfBoundsException,
  equals2au1ep9vhcato as equals,
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
  AbstractMutableList192xfq8ycgofs as AbstractMutableList,
  copyToArray2j022khrow2yi as copyToArray,
  get_lastIndex1yw0x4k50k51w as get_lastIndex,
  joinToStringxqcavsxcmh4q as joinToString,
  protoOf180f3jzyo7rfj as protoOf,
  RandomAccess1jbw8sdogqb8x as RandomAccess,
} from './kotlin-kotlin-stdlib.mjs';
import { get_atomicfu$reentrantLock3o926yhldwf1 as get_atomicfu$reentrantLock } from './kotlinx-atomicfu.mjs';
//region block: imports
//endregion
//region block: pre-declaration
class DoubleList {}
function getAt(index) {
  return this.f1(index);
}
function toDoubleArray() {
  var tmp = 0;
  var tmp_0 = this.d1();
  var tmp_1 = new Float64Array(tmp_0);
  while (tmp < tmp_0) {
    var tmp_2 = tmp;
    tmp_1[tmp_2] = this.f1(tmp_2);
    tmp = tmp + 1 | 0;
  }
  return tmp_1;
}
function listIterator() {
  return this.v2(0);
}
function listIterator_0(index) {
  return this.w2(index, this.d1()).u2();
}
function subList(fromIndex, toIndex) {
  return SimpleSubList(fromIndex, toIndex, DoubleList$subList$lambda(this));
}
function contains(element) {
  return containsCheck(this, element);
}
function containsAll(elements) {
  return containsAllCheck(this, elements);
}
function isEmpty() {
  return this.d1() === 0;
}
function iterator() {
  return this.u2();
}
class Mixin {
  constructor(extra) {
    extra = extra === VOID ? null : extra;
    this.x1i_1 = extra;
  }
  y1i(_set____db54di) {
    this.x1i_1 = _set____db54di;
  }
  z1i() {
    return this.x1i_1;
  }
}
class Property {
  constructor(name, defaultGen) {
    name = name === VOID ? null : name;
    this.a1j_1 = name;
    this.b1j_1 = defaultGen;
  }
}
class PropertyThis {
  constructor(name, defaultGen) {
    name = name === VOID ? null : name;
    this.c1j_1 = name;
    this.d1j_1 = defaultGen;
    var tmp = this;
    tmp.e1j_1 = Extra$PropertyThis$transform$lambda;
  }
}
class ExtraObject {
  constructor() {
    var tmp = this;
    // Inline function 'kotlinx.atomicfu.locks.reentrantLock' call
    tmp.f1j_1 = get_atomicfu$reentrantLock();
    this.g1j_1 = HashMap.f8();
    var tmp_0 = this;
    // Inline function 'korlibs.datastructure.ExtraObject.lock' call
    // Inline function 'kotlinx.atomicfu.locks.withLock' call
    this.f1j_1;
    // Inline function 'korlibs.datastructure.ExtraObject.values.<anonymous>' call
    tmp_0.h1j_1 = toMutableList(this.g1j_1.i3());
  }
  d1() {
    // Inline function 'korlibs.datastructure.ExtraObject.lock' call
    // Inline function 'kotlinx.atomicfu.locks.withLock' call
    this.f1j_1;
    // Inline function 'korlibs.datastructure.ExtraObject.<get-size>.<anonymous>' call
    return this.g1j_1.d1();
  }
  m1() {
    // Inline function 'korlibs.datastructure.ExtraObject.lock' call
    // Inline function 'kotlinx.atomicfu.locks.withLock' call
    this.f1j_1;
    // Inline function 'korlibs.datastructure.ExtraObject.<get-entries>.<anonymous>' call
    // Inline function 'kotlin.collections.associateWith' call
    var this_0 = this.g1j_1.e3();
    var result = LinkedHashMap.bc(coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16));
    // Inline function 'kotlin.collections.associateWithTo' call
    var tmp0_iterator = this_0.a1();
    while (tmp0_iterator.b1()) {
      var element = tmp0_iterator.c1();
      // Inline function 'korlibs.datastructure.ExtraObject.<get-entries>.<anonymous>.<anonymous>' call
      var tmp$ret$0 = this.g1j_1.d3(element);
      result.f3(element, tmp$ret$0);
    }
    return toMutableSet(toMutableMap(result).m1());
  }
  e3() {
    // Inline function 'korlibs.datastructure.ExtraObject.lock' call
    // Inline function 'kotlinx.atomicfu.locks.withLock' call
    this.f1j_1;
    // Inline function 'korlibs.datastructure.ExtraObject.<get-keys>.<anonymous>' call
    return toMutableSet(this.g1j_1.e3());
  }
  i3() {
    return this.h1j_1;
  }
  xh(key) {
    // Inline function 'korlibs.datastructure.ExtraObject.lock' call
    // Inline function 'kotlinx.atomicfu.locks.withLock' call
    this.f1j_1;
    // Inline function 'korlibs.datastructure.ExtraObject.get.<anonymous>' call
    return this.g1j_1.d3(key);
  }
  d3(key) {
    if (!(!(key == null) ? typeof key === 'string' : false))
      return null;
    return this.xh((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
  }
  i1j(key, value) {
    // Inline function 'korlibs.datastructure.ExtraObject.lock' call
    // Inline function 'kotlinx.atomicfu.locks.withLock' call
    this.f1j_1;
    this.g1j_1.f3(key, value);
    return Unit_instance;
  }
  j1j(key) {
    // Inline function 'korlibs.datastructure.ExtraObject.lock' call
    // Inline function 'kotlinx.atomicfu.locks.withLock' call
    this.f1j_1;
    // Inline function 'korlibs.datastructure.ExtraObject.contains.<anonymous>' call
    // Inline function 'kotlin.collections.contains' call
    // Inline function 'kotlin.collections.containsKey' call
    var this_0 = this.g1j_1;
    return (isInterface(this_0, KtMap) ? this_0 : THROW_CCE()).b3(key);
  }
  g1() {
    return this.d1() === 0;
  }
  y2() {
    // Inline function 'korlibs.datastructure.ExtraObject.lock' call
    // Inline function 'kotlinx.atomicfu.locks.withLock' call
    this.f1j_1;
    this.g1j_1.y2();
    return Unit_instance;
  }
  k1j(key) {
    // Inline function 'korlibs.datastructure.ExtraObject.lock' call
    // Inline function 'kotlinx.atomicfu.locks.withLock' call
    this.f1j_1;
    // Inline function 'korlibs.datastructure.ExtraObject.remove.<anonymous>' call
    return this.g1j_1.g3(key);
  }
  g3(key) {
    if (!(!(key == null) ? typeof key === 'string' : false))
      return null;
    return this.k1j((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
  }
  l1j(from) {
    // Inline function 'korlibs.datastructure.ExtraObject.lock' call
    // Inline function 'kotlinx.atomicfu.locks.withLock' call
    this.f1j_1;
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s = from.m1().a1();
    while (_iterator__ex2g4s.b1()) {
      var _destruct__k2r9zo = _iterator__ex2g4s.c1();
      // Inline function 'kotlin.collections.component1' call
      var key = _destruct__k2r9zo.n1();
      // Inline function 'kotlin.collections.component2' call
      var value = _destruct__k2r9zo.o1();
      // Inline function 'kotlin.collections.set' call
      this.g1j_1.f3(key, value);
    }
    return Unit_instance;
  }
  h3(from) {
    return this.l1j(from);
  }
  m1j(key, value) {
    // Inline function 'korlibs.datastructure.ExtraObject.lock' call
    // Inline function 'kotlinx.atomicfu.locks.withLock' call
    this.f1j_1;
    this.g1j_1.f3(key, value);
    return Unit_instance;
  }
  f3(key, value) {
    var tmp = (!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE();
    return this.m1j(tmp, (value == null ? true : !(value == null)) ? value : THROW_CCE());
  }
  n1j(key) {
    // Inline function 'korlibs.datastructure.ExtraObject.lock' call
    // Inline function 'kotlinx.atomicfu.locks.withLock' call
    this.f1j_1;
    // Inline function 'korlibs.datastructure.ExtraObject.containsKey.<anonymous>' call
    // Inline function 'kotlin.collections.contains' call
    // Inline function 'kotlin.collections.containsKey' call
    var this_0 = this.g1j_1;
    return (isInterface(this_0, KtMap) ? this_0 : THROW_CCE()).b3(key);
  }
  b3(key) {
    if (!(!(key == null) ? typeof key === 'string' : false))
      return false;
    return this.n1j((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
  }
}
class MutableListEx {}
function setAddAll(index, elements, offset, size) {
  // Inline function 'kotlin.math.min' call
  var b = this.d1() - index | 0;
  var setCount = Math.min(size, b);
  this.v1j(index, elements, offset, setCount);
  this.w1j(elements, offset + setCount | 0, size - setCount | 0);
}
function setAddAll$default(index, elements, offset, size, $super) {
  offset = offset === VOID ? 0 : offset;
  size = size === VOID ? elements.d1() - offset | 0 : size;
  var tmp;
  if ($super === VOID) {
    this.u1j(index, elements, offset, size);
    tmp = Unit_instance;
  } else {
    setAddAll(index, elements, offset, size);
    tmp = Unit_instance;
  }
  return tmp;
}
function setAll(index, elements, offset, size) {
  var inductionVariable = 0;
  if (inductionVariable < size)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      this.z2(index + n | 0, elements.f1(offset + n | 0));
    }
     while (inductionVariable < size);
}
function addAll_0(elements, offset, size) {
  var inductionVariable = 0;
  if (inductionVariable < size)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      this.h(elements.f1(offset + n | 0));
    }
     while (inductionVariable < size);
}
function removeToSize(size) {
  this.v6(size, this.d1());
}
class SimpleSubList$1 extends AbstractList {
  static a1k($toIndex, $fromIndex, $get, $box) {
    if ($box === VOID)
      $box = {};
    $box.x1j_1 = $toIndex;
    $box.y1j_1 = $fromIndex;
    $box.z1j_1 = $get;
    return this.ni($box);
  }
  d1() {
    return this.x1j_1 - this.y1j_1 | 0;
  }
  f1(index) {
    if (!(0 <= index ? index < this.d1() : false))
      throw IndexOutOfBoundsException.yd();
    return this.z1j_1(index + this.y1j_1 | 0);
  }
}
class Fixed {
  constructor(value) {
    this.b1k_1 = value;
  }
  c1k() {
    return this.b1k_1;
  }
  toString() {
    return 'Fixed(value=' + toString(this.b1k_1) + ')';
  }
  hashCode() {
    return hashCode(this.b1k_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Fixed))
      return false;
    var tmp0_other_with_cast = other instanceof Fixed ? other : THROW_CCE();
    if (!equals(this.b1k_1, tmp0_other_with_cast.b1k_1))
      return false;
    return true;
  }
}
class FastArrayList extends AbstractMutableList {
  static d1k(__array) {
    var $this = this.s6();
    $this.p1j_1 = __array;
    return $this;
  }
  static r1j() {
    // Inline function 'kotlin.emptyArray' call
    var tmp$ret$0 = [];
    return this.d1k(tmp$ret$0);
  }
  static q1j(initialCapacity) {
    // Inline function 'kotlin.emptyArray' call
    var tmp$ret$0 = [];
    return this.d1k(tmp$ret$0);
  }
  d1() {
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return this.p1j_1.length;
  }
  f1(index) {
    // Inline function 'korlibs.datastructure.get' call
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.js.asDynamic' call
    return this.p1j_1[rangeCheck(this, index)];
  }
  z2(index, element) {
    rangeCheck(this, index);
    // Inline function 'kotlin.apply' call
    // Inline function 'korlibs.datastructure.get' call
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.js.asDynamic' call
    var this_0 = this.p1j_1[index];
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.FastArrayList.set.<anonymous>' call
    // Inline function 'korlibs.datastructure.set' call
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.js.asDynamic' call
    this.p1j_1[index] = element;
    return this_0;
  }
  h(element) {
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    this.p1j_1.push(element);
    this.h6_1 = this.h6_1 + 1 | 0;
    return true;
  }
  t6(index, element) {
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    this.p1j_1.splice(insertionRangeCheck(this, index), 0, element);
    this.h6_1 = this.h6_1 + 1 | 0;
  }
  e1(elements) {
    // Inline function 'kotlin.collections.toTypedArray' call
    var tmp$ret$0 = copyToArray(elements);
    return _addAll(this, tmp$ret$0);
  }
  a3(index) {
    rangeCheck(this, index);
    this.h6_1 = this.h6_1 + 1 | 0;
    var tmp;
    if (index === 0) {
      // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp = this.p1j_1.shift();
    } else if (index === get_lastIndex(this)) {
      // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp = this.p1j_1.pop();
    } else {
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp = this.p1j_1.splice(index, 1)[0];
    }
    return tmp;
  }
  x2(element) {
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var array = this.p1j_1;
    var inductionVariable = 0;
    var last = array.length;
    if (inductionVariable < last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.datastructure.get' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$4 = array[index];
        if (equals(tmp$ret$4, element)) {
          array.splice(index, 1);
          this.h6_1 = this.h6_1 + 1 | 0;
          return true;
        }
      }
       while (inductionVariable < last);
    return false;
  }
  v6(fromIndex, toIndex) {
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    this.p1j_1.splice(fromIndex, toIndex - fromIndex | 0);
    this.h6_1 = this.h6_1 + 1 | 0;
  }
  y2() {
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    this.p1j_1.length = 0;
    this.h6_1 = this.h6_1 + 1 | 0;
  }
  w6(element) {
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return this.p1j_1.indexOf(element);
  }
  toString() {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$4 = this.p1j_1;
    return '[' + joinToString(tmp$ret$4, ', ') + ']';
  }
  t7() {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.js.asDynamic' call
    return this.p1j_1.concat();
  }
  toArray() {
    return this.t7();
  }
}
//endregion
function DoubleList$subList$lambda(this$0) {
  return function (it) {
    return this$0.f1(it);
  };
}
function Extra$PropertyThis$transform$lambda(_this__u8e3s4, it) {
  return it;
}
function getExtra(_this__u8e3s4, name) {
  var tmp3_safe_receiver = _this__u8e3s4.z1i();
  return tmp3_safe_receiver == null ? null : tmp3_safe_receiver.xh(name);
}
function setExtra(_this__u8e3s4, name, value) {
  if (_this__u8e3s4.z1i() == null) {
    if (value == null)
      return Unit_instance;
    _this__u8e3s4.y1i(ExtraTypeCreate());
  }
  var tmp4_safe_receiver = _this__u8e3s4.z1i();
  if (tmp4_safe_receiver == null)
    null;
  else {
    tmp4_safe_receiver.i1j(name, value);
  }
}
function hasExtra(_this__u8e3s4, name) {
  var tmp2_safe_receiver = _this__u8e3s4.z1i();
  return (tmp2_safe_receiver == null ? null : tmp2_safe_receiver.j1j(name)) === true;
}
function getExtraTyped(_this__u8e3s4, name) {
  var tmp = _this__u8e3s4.z1i();
  var tmp1_safe_receiver = (!(tmp == null) ? isInterface(tmp, KtMutableMap) : false) ? tmp : null;
  return tmp1_safe_receiver == null ? null : tmp1_safe_receiver.d3(name);
}
function ExtraTypeCreate() {
  return new ExtraObject();
}
function fastArrayListOf(values) {
  // Inline function 'kotlin.also' call
  var this_0 = FastArrayList.q1j(values.length);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.datastructure.fastArrayListOf.<anonymous>' call
  addAll(this_0, values);
  return this_0;
}
function toFastList(_this__u8e3s4) {
  // Inline function 'kotlin.also' call
  var this_0 = FastArrayList.q1j(_this__u8e3s4.length);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.datastructure.toFastList.<anonymous>' call
  // Inline function 'korlibs.datastructure.fastForEach' call
  var n = 0;
  while (n < _this__u8e3s4.length) {
    // Inline function 'korlibs.datastructure.toFastList.<anonymous>.<anonymous>' call
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    var it = _this__u8e3s4[_unary__edvuaz];
    this_0.h(it);
  }
  return this_0;
}
function toFastList_0(_this__u8e3s4, out) {
  out = out === VOID ? FastArrayList.r1j() : out;
  out.s1j(0, _this__u8e3s4);
  out.t1j(_this__u8e3s4.d1());
  return out;
}
function SimpleSubList(fromIndex, toIndex, get) {
  return SimpleSubList$1.a1k(toIndex, fromIndex, get);
}
function containsCheck(collection, element) {
  var _iterator__ex2g4s = collection.a1();
  while (_iterator__ex2g4s.b1()) {
    var v = _iterator__ex2g4s.c1();
    if (equals(v, element))
      return true;
  }
  return false;
}
function containsAllCheck(collection, elements) {
  var elementsMap = toMutableSet(elements);
  var _iterator__ex2g4s = collection.a1();
  while (_iterator__ex2g4s.b1()) {
    var v = _iterator__ex2g4s.c1();
    elementsMap.x2(v);
  }
  return elementsMap.g1();
}
function Resourceable(value) {
  return new Fixed(value);
}
function _addAll($this, elements) {
  // Inline function 'kotlin.collections.isEmpty' call
  if (elements.length === 0)
    return false;
  // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$3 = $this.p1j_1;
  (function () {
    var $externalVarargReceiverTmp = tmp$ret$3;
    return $externalVarargReceiverTmp.push.apply($externalVarargReceiverTmp, [].slice.call(elements.slice()));
  }.call(this));
  $this.h6_1 = $this.h6_1 + 1 | 0;
  return true;
}
function rangeCheck($this, index) {
  if (index < 0 || index >= $this.d1())
    throw IndexOutOfBoundsException.zd('index: ' + index + ', size: ' + $this.d1());
  return index;
}
function insertionRangeCheck($this, index) {
  if (index < 0 || index > $this.d1())
    throw IndexOutOfBoundsException.zd('index: ' + index + ', size: ' + $this.d1());
  return index;
}
//region block: post-declaration
initMetadataForInterface(DoubleList, 'DoubleList', VOID, VOID, [Collection]);
initMetadataForClass(Mixin, 'Mixin', Mixin);
initMetadataForClass(Property, 'Property');
initMetadataForClass(PropertyThis, 'PropertyThis');
initMetadataForClass(ExtraObject, 'ExtraObject', ExtraObject, VOID, [KtMutableMap]);
initMetadataForInterface(MutableListEx, 'MutableListEx', VOID, VOID, [KtMutableList]);
initMetadataForClass(SimpleSubList$1);
initMetadataForClass(Fixed, 'Fixed', VOID, VOID, VOID, [0]);
protoOf(FastArrayList).w1j = addAll_0;
protoOf(FastArrayList).u1j = setAddAll;
protoOf(FastArrayList).s1j = setAddAll$default;
protoOf(FastArrayList).v1j = setAll;
protoOf(FastArrayList).t1j = removeToSize;
initMetadataForClass(FastArrayList, 'FastArrayList', FastArrayList.r1j, VOID, [AbstractMutableList, MutableListEx, RandomAccess]);
//endregion
//region block: exports
export {
  containsAll as containsAll1oa5i6t9xmbdv,
  contains as containsteg8664aaglk,
  getAt as getAt237u54ctbxwvd,
  isEmpty as isEmptyrqh4vz39e0v6,
  iterator as iterator300ls4j24zqzz,
  listIterator as listIterator247sl90ooi4qv,
  listIterator_0 as listIterator1a2ckgeamf7jc,
  subList as subList28p829u9d5w23,
  DoubleList as DoubleList2honu8rif2roh,
  Mixin as Mixin3lmkm5hum2vdj,
  PropertyThis as PropertyThis2r0hbk1cs09wj,
  Property as Property1m5vulkepgwzd,
  FastArrayList as FastArrayListw5fr1wlp4slq,
  fastArrayListOf as fastArrayListOf1rdodhrpn0q8y,
  getExtraTyped as getExtraTyped8zexqxz5xxli,
  getExtra as getExtra307y0o9pd6mp3,
  hasExtra as hasExtra1969mplo13qgb,
  setExtra as setExtra314k0z6q35eku,
  toFastList_0 as toFastList1btvvxvv57pw,
  toFastList as toFastListzo2jtkrx0z5y,
  Resourceable as Resourceable38whwgli3ts8g,
};
//endregion
